var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.253513 0.249224C0.173183 0.328897 0.109424 0.423687 0.0659126 0.528126C0.0224015 0.632565 0 0.744586 0 0.857726C0 0.970866 0.0224015 1.08289 0.0659126 1.18733C0.109424 1.29176 0.173183 1.38655 0.253513 1.46623L4.17878 5.3915C4.25911 5.47117 4.32287 5.56596 4.36638 5.6704C4.40989 5.77484 4.4323 5.88686 4.4323 6C4.4323 6.11314 4.40989 6.22516 4.36638 6.3296C4.32287 6.43404 4.25911 6.52883 4.17878 6.6085L0.253513 10.5338C0.173183 10.6134 0.109424 10.7082 0.0659126 10.8127C0.0224015 10.9171 0 11.0291 0 11.1423C0 11.2554 0.0224015 11.3674 0.0659126 11.4719C0.109424 11.5763 0.173183 11.6711 0.253513 11.7508C0.414091 11.9104 0.631311 12 0.85773 12C1.08415 12 1.30137 11.9104 1.46195 11.7508L5.39579 7.81694C5.87728 7.33485 6.14773 6.68135 6.14773 6C6.14773 5.31865 5.87728 4.66515 5.39579 4.18306L1.46195 0.249224C1.30137 0.0895987 1.08415 0 0.85773 0C0.631311 0 0.414091 0.0895987 0.253513 0.249224Z",
    fill: "#404651"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightarrow);
export default __webpack_public_path__ + "static/media/rightarrow.866400e6c2c3ba6422eda1ca46b79428.svg";
export { ForwardRef as ReactComponent };